/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Newpasswordplaceholder2Inputs */

const zh_auth_newpasswordplaceholder2 = /** @type {(inputs: Auth_Newpasswordplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入新密码`)
};

const en_auth_newpasswordplaceholder2 = /** @type {(inputs: Auth_Newpasswordplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your new password`)
};

const es_auth_newpasswordplaceholder2 = /** @type {(inputs: Auth_Newpasswordplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa tu nueva contraseña`)
};

/**
* | output |
* | --- |
* | "Enter your new password" |
*
* @param {Auth_Newpasswordplaceholder2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_newpasswordplaceholder2 = /** @type {((inputs?: Auth_Newpasswordplaceholder2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Newpasswordplaceholder2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_newpasswordplaceholder2(inputs)
	if (locale === "en") return en_auth_newpasswordplaceholder2(inputs)
	return es_auth_newpasswordplaceholder2(inputs)
});
export { auth_newpasswordplaceholder2 as "auth_newPasswordPlaceholder" }